// extracted by mini-css-extract-plugin
export default {"brands_grid":"style_brands_grid__ZMtYY","brands_grid_item":"style_brands_grid_item__Tk7co"};